import React, { useState } from 'react';
import logo from '../assets/logo.png';
import { BOOKING_URL, branch } from '../data/siteData';

const navLinks = [
  { label: 'Ana Sayfa',        href: '#home' },
  { label: 'Hakkımızda',       href: '#about' },
  { label: 'Hizmetlerimiz',    href: '#services' },
  { label: 'Konum & İletişim', href: '#contact' },
];

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="nav-wrapper">

        {/* Logo */}
        <a href="#home" className="logo">
          <div className="logo-circle">
            <img src={logo} alt="Bloome Beauty Batıkent" />
          </div>
          <div className="logo-text">
            <div className="brand-name">
              <span className="brand-line-primary">Bloome</span>
              <span className="brand-line-secondary">Beauty Batıkent</span>
            </div>
          </div>
        </a>

        {/* Desktop nav */}
        <nav className="nav-menu">
          {navLinks.map((link) => (
            <a key={link.label} href={link.href} className="nav-link">
              {link.label}
            </a>
          ))}
        </nav>

        {/* Desktop right */}
        <div className="nav-right">
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn-appointment">
            Randevu Al
          </a>
        </div>

        {/* Hamburger (visible on mobile via CSS) */}
        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menü"
          style={{ background: 'none', border: 'none' }}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={{
          background: '#fff',
          borderTop: '1px solid #f0f0f0',
          padding: '16px 20px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingBottom: 16, marginBottom: 8, borderBottom: '1px solid #f5f5f5' }}>
            <div className="logo-circle" style={{ width: 44, height: 44 }}>
              <img src={logo} alt="Bloome" />
            </div>
            <div className="logo-text">
              <div className="brand-name">
                <span className="brand-line-primary">Bloome</span>
                <span className="brand-line-secondary">Beauty Batıkent</span>
              </div>
            </div>
          </div>
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              style={{ display: 'block', padding: '12px 8px', fontWeight: 500, color: '#333', borderBottom: '1px solid #f9f9f9', fontSize: '0.95rem' }}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 16 }}>
            <a href={`tel:${branch.phonePlain}`} className="btn btn-outline" style={{ textAlign: 'center' }}>
              📞 {branch.phone}
            </a>
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-appointment"
              style={{ display: 'block', textAlign: 'center' }}
              onClick={() => setMenuOpen(false)}
            >
              Randevu Al
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
